import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { reportsService } from '../services/api';
import { StockReportResult } from '../types/reports';

export interface UseStockReportFilters {
  startDate?: string;
  endDate?: string;
  searchTerm?: string;
  category?: string;
  includeInactive?: boolean;
  includeZeroBalances?: boolean;
  movementPageSize?: number;
  maxMovementPages?: number;
  cnpj?: string;
}

export const useStockReport = (filters: UseStockReportFilters, enabled = true) => {
  const queryParams = useMemo(
    () => ({
      startDate: filters.startDate,
      endDate: filters.endDate,
      searchTerm: filters.searchTerm,
      category: filters.category,
      includeInactive: filters.includeInactive,
      includeZeroBalances: filters.includeZeroBalances,
      movementPageSize: filters.movementPageSize,
      maxMovementPages: filters.maxMovementPages,
      cnpj: filters.cnpj,
    }),
    [filters],
  );

  return useQuery<StockReportResult, Error>({
    queryKey: ['stock-report', queryParams],
    queryFn: () => reportsService.getStockReport(queryParams),
    enabled,
    staleTime: 1000 * 60 * 2,
  });
};
